// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {includes} from 'lodash';

// Components
import Button from '../core/button';

// Styles
import './create-shell-buttons.scss';
import GraceNoteControlsGroup from './send-to-gracenote';

function CreateShellButtons({
    bulkMapping,
    cancelMapping,
    fetched,
    hasAccessByType,
    lastMassItem,
    mapItem,
    mappingSetDataFromShell,
    mappingSetShowRememberMapping,
    mappingSkipMassMapping,
    massMapping,
    massShell,
    massShellActive,
    shellContentType,
    showRememberMapping,
    validShell,
}) {
    const shouldDisableCompleteMapping = () => !validShell;

    const skipMediaItem = () => {
        mappingSkipMassMapping();
    };

    const rememberMapping = () => {
        mappingSetDataFromShell().then(() => mappingSetShowRememberMapping(true));
    };

    const hasWriteAccess = () => hasAccessByType({accessRequirement: 'write'});

    const shouldRenderButton = (type) => {
        const conditional = {
            cancelMapping: () => !massShell && !fetched && !massMapping,
            cancelMassMapping: () => massShell && massShellActive,
            completeMapping: () => !fetched && !bulkMapping,
            rememberMapping: () =>
                !fetched &&
                !massMapping &&
                !showRememberMapping &&
                hasWriteAccess() &&
                !massShell &&
                includes(['MOV', 'SPM', 'SRE'], shellContentType),
            saveAndContinue: () => !fetched && shellContentType === 'SRM',
            skipMediaItem: () => !fetched && massShell && massShellActive,
        };

        return conditional[type] ? conditional[type]() : false;
    };

    const handleCompleteMappingClick = () => {
        mappingSetDataFromShell().then(() => mapItem());
    };

    const handleContinueClick = () => {
        mappingSetDataFromShell(true, false);
    };

    const renderButton = (type) => {
        const renderButtonProps = {
            cancelMassMapping: {
                children: 'Exit Mass Shell',
                onClick: cancelMapping,
            },
            cancelMapping: {
                children: bulkMapping ? 'Exit Bulk Mapping' : 'Cancel Mapping',
                onClick: cancelMapping,
            },
            completeMapping: {
                children: massShell
                    ? lastMassItem
                        ? 'Complete Mapping And Exit'
                        : 'Complete Mapping And Next'
                    : shellContentType === 'SRM'
                      ? 'Force Complete Mapping'
                      : 'Complete Mapping',
                disabled: shouldDisableCompleteMapping(),
                onClick: handleCompleteMappingClick,
            },
            saveAndContinue: {
                children: 'Save And Continue',
                disabled: shouldDisableCompleteMapping(),
                onClick: handleContinueClick,
            },
            skipMediaItem: {
                children: 'Skip Media Item',
                onClick: skipMediaItem,
            },
            rememberMapping: {
                children: 'Map & Remember',
                disabled: shouldDisableCompleteMapping(),
                onClick: rememberMapping,
            },
        };

        return shouldRenderButton(type) ? (
            <Button {...renderButtonProps[type]} className="create-shell-buttons--button" />
        ) : null;
    };

    return (
        <div className="create-shell-buttons--actions">
            {renderButton('completeMapping')}
            {renderButton('saveAndContinue')}
            {renderButton('skipMediaItem')}
            {renderButton('rememberMapping')}
            {renderButton('cancelMassMapping')}
            {renderButton('cancelMapping')}
            <GraceNoteControlsGroup isMoviesAndPrograms={false} />
        </div>
    );
}

CreateShellButtons.propTypes = {
    bulkMapping: PropTypes.bool,
    cancelMapping: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    hasAccessByType: PropTypes.func.isRequired,
    lastMassItem: PropTypes.bool,
    mapItem: PropTypes.func.isRequired,
    mappingSetDataFromShell: PropTypes.func.isRequired,
    mappingSetShowRememberMapping: PropTypes.func.isRequired,
    mappingSkipMassMapping: PropTypes.func.isRequired,
    massMapping: PropTypes.bool,
    massShell: PropTypes.bool,
    massShellActive: PropTypes.bool,
    shellContentType: PropTypes.string,
    showRememberMapping: PropTypes.bool,
    validShell: PropTypes.bool,
};

export default CreateShellButtons;
